<template>
  <div>
    <h1>
      {{ feederName }}
    </h1>
  
    <feeder-total-cal v-bind:feederId="$route.params.feederId"></feeder-total-cal>
  </div>
</template>

<script>
import { ApiTls } from "../../src/app/tools/ApiTls";
// import { LineTls } from "../app/tools/LineTls";
// import { PoleTls } from "../app/tools/PoleTls";
import FeederTotalCal from "../components/FeederTotalCal";
export default {
  name: "PreCAL",
  components:{FeederTotalCal},
  data() {
    return {
      myData: { linesArr: [], feeder: [], a_sub: [], polesArr: [], l_sub: [] },
      // ttlArr: {
      //   n_branch_1ph: "تعداد مشترکین سبک تکفاز",
      //   n_branch_3ph: "تعداد مشترکین سه فاز",
      //   l_branch: "متراژ کابل سرویس مشترک سبک",
      //   n_branch_light: "روشنایی",
      //   n_branch_con: "تعداد کابل مجتمع",
      //   "LV-Wire-Cu-6": "هادی مس 6",
      //   "LV-Wire-Cu-10": "هادی مس 10",
      //   "LV-Wire-Cu-16": "هادی مس 16",
      //   "LV-Wire-Cu-25": "هادی مس 25",
      //   "LV-Wire-Cu-35": "هادی مس 35",
      //   new_ssc: "متراژ جدید",
      // },
      feederName: "",
    };
  },
  mounted() {
    ApiTls.getFeederData(this.$route.params.feederId, this.setResData);
  },
  methods: {
    setResData(res) {
      this.myData = res.data;
    },
  },

  computed: {
    // banches() {
    //   return PoleTls.sumBranches(this.myData.polesArr);
    // },
    // cuLines() {
    //   return LineTls.sumCuLines(this.myData.linesArr);
    // },
    toShow() {
      return this.myData.length > 0;
    },
      // feederName(){
      //     if(this.myData.feeder.length) return this.myData.feeder.feeder_name;
      //     else return '';
      // }
  },
  watch: {
    myData() {
      if (this.myData.feeder.length)
        this.feederName = this.myData.feeder[0]["feeder_name"];
      else this.feederName = "";
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: VazirFD;
  src: url("./../../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.eot");
  src: url("./../../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.eot?#iefix")
      format("embedded-opentype"),
    url("./../../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.woff2")
      format("woff2"),
    url("./../../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.woff")
      format("woff"),
    url("./../../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.ttf")
      format("truetype");

  font-weight: normal;
  font-style: normal;
}

* {
  font-family: "VazirFD", sans-serif;
}
</style>